<template>
  <li class="search-list-item"
      :class="itemStyles">
    <div class="search-icon">
      <div v-if="searchEngine"
            :style="getEngineIcon"
            class="engine-icon"></div>
      <icon-magnifier v-else
                      width="18"
                      height="18" />
    </div>

    <div class="serach-info">
      <div class="terms">
        <span class="query">{{ searchTerms }}</span>
      </div>

      <div class="device">
        {{ device ? device.name : '' }}
      </div>

      <div v-if="isToday(item.time)" class="time">
        {{ item.time | timeAgo }}
      </div>

      <div v-else class="time">
        {{ item.time | localTime }}
      </div>
    </div>
  </li>
</template>

<script>
  import searchEngineCodes from '@/constants/searchEngineCodes.js'
  import searchEnginePictures from '@/constants/searchEnginePictures.js'
  import { isToday } from '@/services/intl'

  export default {
    props: {
      item: {
        required: true,
        type: Object
      }
    },

    methods: {
      isToday
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.item.user_id)
      },

      device() {
        return this.child.devices.find(device => device.id === this.item.device_id)
      },

      searchTerms() {
        return this.item.details.search_terms.join(' ')
      },

      searchEngine() {
        return searchEngineCodes[this.item.details.engine]
      },

      getEngineIcon() {
        let icon = searchEnginePictures[this.searchEngine]

        return {
          'background-image': 'url(' + icon + ')',
          'background-size': 'cover',
          'background-position': 'center'
        }
      },

      itemStyles() {
        return {
          'search-list-item-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-list-item {
    display: flex;
    align-items: center;

    padding: 15px 0;
    min-height: 64px;
    border-top: 1px solid #f2f2f2;

    .search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 32px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #e5e5e5;

      .engine-icon {
        width: 18px;
        height: 18px;
        border-radius: 50%;
      }
    }

    .serach-info {
      display: flex;
      align-items: center;
      width: 100%;

      .terms {
        display: flex;
        align-items: center;
        flex: 2 0;

        .query {
          margin-left: 20px;
        }
      }

      .device, .time {
        flex: 1 0;
        text-align: right;
        color: rgba(#3e3a3b, .7);
      }
    }

    &:last-child {
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .search-list-item-mobile {
    .serach-info {
      flex-wrap: wrap;

      .terms {
        width: 100%;
        flex: unset;
      }

      .device {
        padding: 0 20px;
      }

      .device, .time {
        flex: unset;
        font-size: 12px;
        padding-top: 5px;
      }
    }
  }
</style>
